<script setup>
import { ref, onMounted, computed, watch } from "vue";
import SubastaUbicaciones from "./SubastaUbicaciones.vue";
import SubastaTerminos from "./SubastaTerminos.vue";

const props = defineProps({
    LotesSubastaStore: Object,
    usuarioStore: Object,
});

// Reactividad
const isLoading = ref(true);
const seccionActual = ref(null);

function setSeccionActual(seccion) {
    seccionActual.value = seccion;
}

onMounted(() => {
    setTimeout(() => {
        isLoading.value = false;
    }, 1000);
});

const secciones = computed(() => {
    const ubicaciones = props.LotesSubastaStore.auction.ubicaciones || [];

    const ubicacionSecciones = ubicaciones.map((u, i) => ({
        slug: `ubicacion-${u.id}`,
        texto: `Ubicación ${u.nombre || i + 1}`,
        ubicacion: u,
    }));

    return [
        ...ubicacionSecciones,
        {
            slug: 'terminos',
            texto: 'Términos y condiciones'
        }
    ];
});

watch(
  () => secciones.value,
  (nuevasSecciones) => {
    if (nuevasSecciones.length && !seccionActual.value) {
      seccionActual.value = nuevasSecciones[0].slug;
    }
  },
  { immediate: true }
);

</script>

<template>

    <div class="container">

    <div class="d-flex justify-content-start gap-2 mt-mb-7 mt-5 mb-4">
        <button v-for="seccion in secciones" :key="seccion.slug" class="btn btn-light text-black"
            :class="{ 'text-primary': seccionActual === seccion.slug }" @click="setSeccionActual(seccion.slug)"
            :aria-selected="seccionActual === seccion.slug">
            {{ seccion.texto }}
        </button>
    </div>

    <div v-if="isLoading" class="text-center mt-3">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
        <p>Cargando contenido, por favor espere...</p>
    </div>

    <div v-for="seccion in secciones" :key="seccion.slug">
        <SubastaUbicaciones v-if="seccion.slug.startsWith('ubicacion') && seccionActual === seccion.slug"
            :LotesSubastaStore="props.LotesSubastaStore" :ubicacion="seccion.ubicacion" />
    </div>

    <SubastaTerminos v-if="seccionActual === 'terminos'" :LotesSubastaStore="props.LotesSubastaStore" :usuarioStore="usuarioStore" />

    </div>
    
</template>

<style>
.btn-light.active,
.btn-light:active,
.btn-light[aria-selected="true"] {
    background-color: #fff !important;
    color: var(--bs-primary) !important;
    border-color: var(--bs-primary) !important;
}

.spinner-border {
    width: 3rem;
    height: 3rem;
}
</style>
